import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="mb-0 text-center">
       
      </footer>
    </>
  );
};

export default Footer;
